export default __webpack_public_path__ + "static/media/acm_factor_blur_table.5ef074fa.png";